import React from 'react';

const AcessoTemporarioContext = React.createContext();

export default AcessoTemporarioContext;